import { Member } from '@aid/members/types/classes';
import { Customer } from '@aid/customers/types/classes';
import { Insurance } from '@aid/insurances/types/classes';

export class Reminder {
  // The reminder form sends null for a reminder that does not exist yet.
  id?: number | null;
  status?: string;
  created?: string | Date;
  dueDate?: string | Date;
  text?: string;
  owner?: number | Member;
  assignee?: number | Member;
  customer?: number | Customer;
  insurance?: number | Insurance;
}
